<script lang="ts">
    import { createEventDispatcher } from "svelte"
    import Icon from "../../../widgets/Icon.svelte"
    import { mdiPencil, mdiTrashCan } from "@mdi/js"
    import { tooltip } from "../../../../helper"
    import { _ } from "svelte-i18n"
    export let title: string = ""

    let dispatch = createEventDispatcher()
    let value = title
    let input: HTMLInputElement
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<div class="cart-title-field" on:click|stopPropagation on:keydown>
    <input size="{value.length}" bind:this="{input}" bind:value on:change="{() => dispatch('change', value)}" />

    <div class="actions">
        <button class="btn btn-link" on:click="{() => input.focus()}" use:tooltip="{{ content: $_('cart.editCart') }}">
            <Icon path="{mdiPencil}" size="24px" />
        </button>
        <button
            class="btn btn-link delete-cart"
            on:click="{() => dispatch('delete')}"
            use:tooltip="{{ content: $_('cart.deleteCart') }}"
        >
            <Icon path="{mdiTrashCan}" size="24px" />
        </button>
    </div>
</div>
